module.exports = __webpack_public_path__ + "static/media/watermark-light-background.904e7d86.svg";